module.exports = __webpack_public_path__ + "img/advantage_4_bg_big.3fdb1e77.png";